import { atomWithKey as atom } from "./atomWithKey";
import { IBookedTrips, INextAndPreviousTrain, ITrip } from "../Types/Index";

export const selectedTripForBookItAgainAtom = atom<IBookedTrips | null>({
    key: "selectedTripForBookItAgainAtom",
    default: null,
});
export const tripOfferAtom = atom<ITrip[]>({
    key: "tripOfferAtom",
    default: [],
});

export const nextAndPreviousTrainAtom = atom<INextAndPreviousTrain>({
    key: "nextAndPreviousTrainAtom",
    default: { previousTrain: null, nextTrain: null },
});